import styled from "styled-components";
import { ThemeProp } from "styles/theme";

import { datastoresMenuFonts } from "styles/font-sizes";

export const StyledWrapper = styled.div`
  z-index: 6;
  display: flex;
  position: relative;

  background: ${({ theme }: ThemeProp) => theme.secondaryColor};
  color: ${({ theme }: ThemeProp) => theme.textInDark};

  &&& * {
    color: inherit;
  }

  height: 100%;
  padding: 5px;

  && .ant-menu-light .ant-menu-submenu-active {
    color: ${({ theme }: ThemeProp) => theme.textInDark};
  }

  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  overflow-y: auto;
  overflow-x: hidden;
  -ms-overflow-style: none;
  //scrollbar-width: none;

  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;

  ::-webkit-scrollbar {
    display: none;
  }

  .bottom-shadow,
  .top-shadow {
    width: 100%;
    height: 30px;
  }

  .bottom-shadow {
    bottom: 0;
    background: linear-gradient(
      180deg,
      transparent,
      ${({ theme }: ThemeProp) => theme.secondaryColor}
    );
  }

  .top-shadow {
    top: 0;
    z-index: 1;
    background: linear-gradient(
      0deg,
      transparent,
      ${({ theme }: ThemeProp) => theme.secondaryColor}
    );
  }

  .ant-menu-submenu,
  .datastore-category {
    opacity: 0;
    transform: scale(0.8);
    transition: all ease-in-out 0.3s;

    &[data-visible="true"] {
      transform: scale(1);
      opacity: 1;
    }
  }

  &,
  & * {
    ::-webkit-scrollbar {
      display: none;
    }
  }

  :hover,
  &[data-pinned="true"] {
    .ant-menu-submenu-title[style] {
      padding-left: 0 !important;
      padding-right: 20px !important;
    }

    .ant-menu {
      //width: 150px;
    }
  }

  :not(:hover):not(&[data-pinned="true"]) {
    .icon-wrapper {
      margin: 0;
    }

    .ant-menu-title-content,
    .ant-menu-submenu-arrow,
    .category-divider-line {
      display: none;
    }

    .datastore-menu-pin-button {
      opacity: 0;
    }

    .category-divider-title {
      white-space: nowrap;
      max-width: 50px;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 5px 2px;
      text-align: center;
    }

    .ant-menu-submenu-title {
      padding: 0;
      display: flex;
      justify-content: center;
    }

    .ant-menu-submenu-title[style] {
      padding-left: 0 !important;
    }

    .ant-menu-sub {
      display: none;
    }
  }
`;

export const StyledPinned = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
  cursor: pointer;
  font-size: ${datastoresMenuFonts.datastorePinned}px;
  padding: 5px;
`;
